(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["journal-article"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const run = () => {
      const root = document.querySelector('[data-journal-article]');
      if (!root) return;
      const body = root.querySelector('.journal-detail__body');
      if (!body) return;

      const images = body.querySelectorAll('img');
      images.forEach((img) => {
        img.classList.add('ibg', 'journal-detail__image');
      });

      const normalizeImageElement = (node) => {
        if (!node || node.nodeType !== 1) return node;
        if (node.classList.contains('block-with-gallery')) return node;
        if (node.tagName === 'IMG') {
          const figure = document.createElement('figure');
          node.before(figure);
          figure.append(node);
          return figure;
        }
        if (node.tagName === 'P') {
          const images = Array.from(node.querySelectorAll('img'));
          if (images.length > 1 && node.textContent.trim() === '') {
            const wrapper = document.createElement('figure');
            wrapper.className = 'block-with-gallery';
            node.before(wrapper);
            images.forEach((img) => {
              const figure = document.createElement('figure');
              figure.append(img);
              wrapper.append(figure);
            });
            node.remove();
            return wrapper;
          }
          if (node.children.length !== 1) return node;
          if (node.textContent.trim() !== '') return node;
          const child = node.children[0];
          if (child.tagName !== 'IMG' && child.tagName !== 'A') return node;
          if (child.tagName === 'A' && !child.querySelector('img')) return node;
          const figure = document.createElement('figure');
          node.replaceWith(figure);
          figure.append(child);
          return figure;
        }
        return node;
      };

      Array.from(body.children).forEach((child) => {
        normalizeImageElement(child);
      });

      const isImageGroup = (node) => {
        if (!node || node.nodeType !== 1) return false;
        if (node.classList.contains('block-with-gallery')) return false;
        if (node.tagName === 'IMG') return true;
        if (node.tagName === 'FIGURE') return !!node.querySelector('img');
        if (node.tagName === 'P') {
          if (node.children.length !== 1) return false;
          if (!node.querySelector('img')) return false;
          return node.textContent.trim() === '';
        }
        return false;
      };

      const children = Array.from(body.children);
      let group = [];
      const flushGroup = () => {
        if (group.length > 1) {
          const wrapper = document.createElement('figure');
          wrapper.className = 'block-with-gallery';
          group[0].before(wrapper);
          group.forEach((node) => wrapper.append(node));
        }
        group = [];
      };

      children.forEach((child) => {
        if (isImageGroup(child)) {
          group.push(child);
        } else {
          flushGroup();
        }
      });

      flushGroup();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run, { once: true });
    } else {
      run();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["welcome-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const popup = document.querySelector('#popup-subscribe');
    if (!popup) return;
    if (document.documentElement.classList.contains('shopify-design-mode')) return;
    if (popup.dataset.welcomeEnabled !== 'true') return;
    if (localStorage.getItem('welcomePopupSubscribed') === 'true') return;
    const delay = Number(popup.dataset.welcomeDelay || 0);

    window.addEventListener('load', () => {
      window.setTimeout(() => {
        const popupModule = window.flsModules && window.flsModules.popup;
        if (!popupModule) return;
        const interval = window.setInterval(() => {
          if (!popupModule.isOpen) {
            popupModule.open('#popup-subscribe');
            window.clearInterval(interval);
          }
        }, 300);
      }, delay);
    });

    const form = document.querySelector('#WelcomeSubscribeForm');
    if (form && form.closest('.popup')) {
      form.addEventListener('submit', () => {
        localStorage.setItem('welcomePopupSubscribed', 'true');
        const popupModule = window.flsModules && window.flsModules.popup;
        if (popupModule) {
          popupModule.close('#popup-subscribe');
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
